function guardianLanguageTarget(currentHref, fallbackHref, alternateHref) {
  const current = new URL(currentHref);
  const fallback = new URL(fallbackHref, current);
  if (fallback.origin !== current.origin) return null;
  let target = fallback;
  if (alternateHref) {
    const alternate = new URL(alternateHref, current);
    if (alternate.origin === current.origin) target = alternate;
  }
  target.search = current.search;
  const currentSpanish = /^\/es(?:\/|$)/u.test(current.pathname);
  const targetSpanish = /^\/es(?:\/|$)/u.test(target.pathname);
  if (currentSpanish !== targetSpanish) {
    let reset = false;
    for (const key of [...target.searchParams.keys()]) {
      if (key.startsWith('filter.v.option.')) {
        target.searchParams.delete(key);
        reset = true;
      }
    }
    if (reset) {
      target.searchParams.delete('page');
      target.searchParams.set('guardian_option_filters_reset', '1');
    }
  }
  target.hash = current.hash;
  return target.href;
}

function guardianShowOptionResetNotice() {
  if (new URL(window.location.href).searchParams.get('guardian_option_filters_reset') !== '1') return;
  const bar = document.querySelector('.guardian-language-bar');
  if (!bar || document.querySelector('.guardian-option-reset-notice')) return;
  const note = document.createElement('p');
  note.className = 'guardian-option-reset-notice';
  note.setAttribute('role', 'status');
  note.textContent = document.documentElement.lang.startsWith('es')
    ? 'Al cambiar de idioma, se restablecieron los filtros de opciones del producto, como color y talla. Selecciónalos de nuevo si los necesitas.'
    : 'Changing language reset product-option filters, such as color and size. Select them again if needed.';
  bar.insertAdjacentElement('afterend', note);
}

function refreshGuardianLanguageLinks() {
  guardianShowOptionResetNotice();
  for (const link of document.querySelectorAll('.guardian-language-bar a[hreflang]')) {
    const locale = link.getAttribute('hreflang');
    const alternate = Array.from(document.querySelectorAll('link[rel="alternate"][hreflang]'))
      .find((item) => item.getAttribute('hreflang') === locale);
    const target = guardianLanguageTarget(window.location.href, link.getAttribute('href'), alternate?.href);
    if (target) link.href = target;
  }
}

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshGuardianLanguageLinks, { once: true });
  } else {
    refreshGuardianLanguageLinks();
  }
  window.addEventListener('hashchange', refreshGuardianLanguageLinks);
  window.addEventListener('popstate', refreshGuardianLanguageLinks);
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('.guardian-language-bar a[hreflang]')) return;
    refreshGuardianLanguageLinks();
  }, true);
}
